import type { ReactNode } from "react";
import type { ItineraryTableSource } from "../types/itineraryTable";
import { ItineraryTablePanel } from "./ItineraryTablePanel";

/** 后台独立表格和客户表格分享共用的只读文档。 */
export function ItineraryTableDocument({ itinerary, actions }: { itinerary: ItineraryTableSource; actions?: ReactNode }) {
  return <article className="itinerary-table-document">
    <header className="itinerary-table-document-header">
      <div><span>行程表格</span><h1>{itinerary.title || "未命名行程"}</h1></div>
      {actions}
    </header>
    <ItineraryTablePanel editor={itinerary} />
  </article>;
}
